import EcoSpace from 'eco-design/base/eco-space';
import EcoGraphicItems from 'eco-design/sections/eco-graphic-items';
import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';

export default function Comp() {
    const { t } = useLang('theProduct.ListA2');
    const { locale } = getLocal();

    const itemsA = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750941348232/list1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1750941350835/list1_h5.jpg',
            title: t('item1_title'),
            desc: t('item1_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1743077603239/list2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1743077606091/list2_h5.jpg',
            title: t('item2_title'),
            desc: t('item2_desc'),
        },
    ];

    if (['uk', 'it'].includes(locale)) return null; // uk和it暂时不显示

    return (
        <div className={styles.ListA2}>
            <EcoSpace />
            <EcoGraphicItems items={itemsA} theme="white" imgHeight="16-9" />
        </div>
    );
}
